import React from 'react';
import './index.css';
import InfoBar from '../InfoBars';

interface CheckboxComponentProps {
    disabled?: boolean;
    className?: string;
    inputType?: 'general' | 'entered' | 'error' | 'success' | 'disabled';
    radioName: string;
    radioButtonGroup: string;
    onRadioButtonChange: (value: string) => void;
    radioValue?: string;
    errorMessage?: string;
    radioId?: string;
    required?: boolean;
    option: any;
    defaultChecked?: string;
}

const RadioButton: React.FC<CheckboxComponentProps> = ({
    disabled,
    inputType = 'general',
    radioName,
    className,
    radioButtonGroup,
    errorMessage,
    required,
    onRadioButtonChange,
    option,
    defaultChecked = ''
}) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onRadioButtonChange(e.target.value);
    };
    return (
        <div className="radio_button">
            <span className={`radio_button_name ${required && 'yes'}`}>{radioName}</span>
            <div className="radio_button_container">
                <div className="buttons">
                    {option && option.length > 0 && option?.map((ele: any, index: number) => {
                        return (<div key={index}>
                            <label htmlFor={ele} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                <input
                                    className={`styled-radio ${className}`}
                                    type="radio"
                                    disabled={disabled}
                                    onChange={handleChange}
                                    name={radioButtonGroup}
                                    value={ele}
                                    defaultChecked={defaultChecked === ele}
                                    id={ele}
                                />
                                {ele}
                            </label>
                        </div>)
                    })}
                </div>
                <div className="radio_button_infoBars">
                    {inputType === 'success' ? (
                        <InfoBar
                            variant="success"
                            message={errorMessage ? errorMessage : 'Success'}
                            className="input_field_class"
                        />
                    ) : (
                        ''
                    )}
                    {inputType === 'error' ? (
                        <InfoBar
                            variant="danger"
                            message={errorMessage ? errorMessage : ''}
                            className="input_field_class"
                        />
                    ) : (
                        ''
                    )}
                </div>
            </div>
        </div>
    );
};

export default RadioButton;
